﻿import {GetParkingOperationStepsArguments} from "../../types/arguments/GetParkingOperationStepsArguments";
import {GetReservationQuotationArguments} from "../../types/arguments/GetReservationQuotationArguments";
import {ParkingPrebookingAvailabilityArguments} from "../../types/arguments/ParkingPrebookingAvailabilityArguments";
import {ReservationQuotationResult} from "../../types/arguments/ReservationQuotationResult";
import {ParkingPrebookingAvailabilityEntry} from "../../types/ParkingPrebookingAvailabilityEntry";
import {QueryOccupationResult} from "../../types/QueryOccupationResult";
import {ListParkingTariffResult} from "../../types/ListParkingTariffResult";
import IPermitsTariffs from "../IPermitsTariffs";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsTariffs implements IPermitsTariffs {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	occupation(signal?: AbortSignal | undefined): Promise<QueryOccupationResult> {
		return this._client.jsonFetch("tariffs/occupation", "GET", null, {
			signal: signal
		});
	}

	quote(data: GetReservationQuotationArguments, signal?: AbortSignal | undefined): Promise<ReservationQuotationResult> {
		return this._client.jsonFetch("tariffs/quote", "POST", data, {
			signal: signal
		});
	}

	available(data: ParkingPrebookingAvailabilityArguments, signal?: AbortSignal | undefined): Promise<ParkingPrebookingAvailabilityEntry[]> {
		return this._client.jsonFetch("tariffs/available", "POST", data, {
			signal: signal
		});
	}

	list(data: GetParkingOperationStepsArguments, signal?: AbortSignal | undefined): Promise<ListParkingTariffResult> {
		return this._client.jsonFetch("tariffs/list", "POST", data, {
			signal: signal
		});
	}
}
